export enum ViewState {
	Read,
	Edit,
	New
}